/**
 * @name Moment
 * @description Configuración de la libreria moment
 * @author Ricardo Guerra
 */

import i18n from 'i18next';
import moment from 'moment';

const setMomentLocale = () => {
  const lsLanguage = JSON.parse(localStorage.getItem('ls.ty-Language'));
  const lang = lsLanguage ? lsLanguage.language : 'es';
  const locale = {
    en: 'en-gb',
    es: 'es-mx',
    pt: 'pt'
  };

  const monthsName = [
    i18n.t('Months.jan'),
    i18n.t('Months.feb'),
    i18n.t('Months.mar'),
    i18n.t('Months.apr'),
    i18n.t('Months.may'),
    i18n.t('Months.jun'),
    i18n.t('Months.jul'),
    i18n.t('Months.aug'),
    i18n.t('Months.sep'),
    i18n.t('Months.oct'),
    i18n.t('Months.nov'),
    i18n.t('Months.dec')
  ];

  const monthsShortName = [
    i18n.t('MonthsShort.jan'),
    i18n.t('MonthsShort.feb'),
    i18n.t('MonthsShort.mar'),
    i18n.t('MonthsShort.apr'),
    i18n.t('MonthsShort.may'),
    i18n.t('MonthsShort.jun'),
    i18n.t('MonthsShort.jul'),
    i18n.t('MonthsShort.aug'),
    i18n.t('MonthsShort.sep'),
    i18n.t('MonthsShort.oct'),
    i18n.t('MonthsShort.nov'),
    i18n.t('MonthsShort.dec')
  ];

  const weekDaysName = [
    i18n.t('WeekDays.sunday'),
    i18n.t('WeekDays.monday'),
    i18n.t('WeekDays.tuesday'),
    i18n.t('WeekDays.wednesday'),
    i18n.t('WeekDays.thursday'),
    i18n.t('WeekDays.friday'),
    i18n.t('WeekDays.saturday')
  ];

  moment.updateLocale('en-gb', {
    months: monthsName, monthsShort: monthsShortName, weekdays: weekDaysName
  });

  moment.updateLocale('es-mx', {
    months: monthsName, monthsShort: monthsShortName, weekdays: weekDaysName
  });

  moment.updateLocale('pt', {
    months: monthsName, monthsShort: monthsShortName, weekdays: weekDaysName
  });

  // Set moment locale
  moment.locale(locale[lang]);
};

export const MomentConfig = {
  setMomentLocale
};
